import {
  DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED,
  CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED,
  SET_EVENT_PRICE_DETAILS_DATA_SHARED
} from './constants';

export const displayEventPriceDetailModal = () => ({
  type: DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED
});

export const setEventPriceDetailData = (basePrice, fees) => ({
  type: SET_EVENT_PRICE_DETAILS_DATA_SHARED,
  payload: {
    basePrice,
    fees
  }
});

export const cancelEventPriceDetailModal = () => ({
  type: CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED
});



// WEBPACK FOOTER //
// ./src/features/shared/eventPriceDetailsModal/actionTypes.js